import React from 'react';

const EmailItem = (params) => {  
    return (
        <div className="card" style={{ maxWidth:"900px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Email ({params.data.title})
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom:"15px" }}>
                        <div className="row">
                            <div className="col-md-6">
                                <b>To:</b> {params.data.to}
                            </div>
                            <div className="col-md-6">
                                <b>From:</b> {params.data.from}
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-md-6">
                                <b style={{ width: "120px!important" }}>Subject:</b> {params.data.subjectOfEmail}
                            </div>
                            <div className="col-md-3">
                                <b>Date:</b> {params.data.created}
                            </div>
                            <div className="col-md-3">
                                <b>Status:</b> {params.data.deliveryStatus == 1 ? "Email Sent" : "Pending"}
                            </div>
                        </div>
                    </div>
                    <div style={{ borderRadius:"10px", padding: "10px", backgroundColor: "#EFEFEF", maxHeight: "300px", overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: params.data.bodyOfEmail }}></div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default EmailItem;